import React from "react";
import { NavLink } from "react-router-dom";
import { FaEllipsisV, FaBars } from "react-icons/fa";
import {
	Button,
	Dropdown,
	Form,
	Navbar,
	Nav,
	Container
} from "react-bootstrap";


function AdminNavbar() {
	const [collapseOpen, setCollapseOpen] = React.useState(false);
	return (
		<>
			<Navbar expand="lg">
				<Container fluid>
					<div className="navbar-wrapper">
						<div className="navbar-minimize">
							<Button className="btn-fill btn-icon d-none d-lg-block" onClick={() => document.body.classList.toggle("sidebar-mini")}>
								<span className="visible-on-sidebar-regular"><FaEllipsisV /></span>
								<span className="visible-on-sidebar-mini"><FaBars /></span>
							</Button>
							<Button className="btn-fill btn-icon d-block d-lg-none" onClick={() => document.documentElement.classList.toggle("nav-open")}>
								<span className="visible-on-sidebar-regular"><FaEllipsisV /></span>
								<span className="visible-on-sidebar-mini"><FaBars /></span>
							</Button>
						</div>
					</div>
					<div className="d-flex align-items-center ml-auto">
						<Dropdown as={Nav.Item}>
							<Dropdown.Toggle as={Nav.Link} id="dropdown-41471887333" variant="default">
								<i className="nc-icon nc-bullet-list-67"></i>
							</Dropdown.Toggle>
							<Dropdown.Menu alignRight aria-labelledby="navbarDropdownMenuLink" >
								<NavLink to="/profile" className="dropdown-item">
									<i className="nc-icon nc-settings-90"></i>
									Profile
								</NavLink>
								<a style={{ "cursor": "pointer" }} className="dropdown-item" onClick={() => { localStorage.removeItem("accessToken"); window.location.replace('/'); localStorage.removeItem("role"); localStorage.removeItem("userName"); localStorage.removeItem("userID"); }}>
									<i className="nc-icon nc-button-power"></i>
									Log out
								</a>
							</Dropdown.Menu>
						</Dropdown>
					</div>
				</Container>
			</Navbar>
		</>
	);
}

export default AdminNavbar;
